module.exports = __webpack_public_path__ + "img/install.d21f03ee.svg";